import {
    FETCH_LOCATIONS_FAILURE,
    FETCH_LOCATIONS_REQUEST,
    FETCH_LOCATIONS_SUCCESS
} from '../../actions/Locations/types';

/**
 *
 * @type FetchLocations
 */
const initialState = {
    loading: false,
    data: null,
    error: null
};

/**
 *
 *
 *
 * @typedef {Object} ACTION
 * @property {string} type
 * @property {Array<*>} [payload]
 * @property {string} [error]
 *
 *
 *
 * @param { FetchLocations} state
 * @param {ACTION} action
 * @param {*} type
 *
 * @return {FetchLocations}
 */
const Locations = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOCATIONS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_LOCATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null
            };
        case FETCH_LOCATIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default Locations;
